module.exports = __webpack_public_path__ + "static/media/Nodata.c043f6e0.svg";